import React, { Fragment, useState } from 'react';
import { useMutation, useQuery } from "@apollo/react-hooks";
import { Table, Loader, Radio, Button, Modal } from 'semantic-ui-react';
import gql from "graphql-tag";

const ProviderList = [
    { ID : "NZ001", provider : "Milford Conservative", fundType: "conservative", average: "2.4%"  },
    { ID : "NZ002", provider : "Generate Moderate", fundType: "moderate", average: "2.4%"  },
    { ID : "NZ003", provider : "Mercer", fundType: "conservative", average: "2.4%"  },
    { ID : "NZ004", provider : "Fisher", fundType: "balanced", average: "2.4%"  },
    { ID : "NZ005", provider : "Booster", fundType: "growth", average: "2.4%"  },
    { ID : "NZ006", provider : "ANZ", fundType: "high growth", average: "2.4%"  },
    { ID : "NZ007", provider : "Pathfinder", fundType: "growth", average: "2.4%"  },
    { ID : "NZ008", provider : "Smartshares (NZX)", fundType: "moderate", average: "2.4%"  },
    { ID : "NZ009", provider : "Medical Assurance Society (MAS)", fundType: "growth", average: "2.4%"  },
];

const KiwiSaver = () => {
    let userKiwiSaver;

    const [errors, setErrors] = useState({});
    const [kiwiSaver, setNewKiwiSaver] = useState(" ");
    const [openChangeKiwiSaverModal, setChangeKiwiSaverModal] = useState(false);
    const [openOptOutKiwiSaverModal, setOptOutKiwiSaverModal] = useState(false);

    const { data } = useQuery(GET_KIWISAVER_QUERY);
    if (data){
        userKiwiSaver = data.getUserKiwiSaver;
    }

    const [updateKiwiSaver] = useMutation(UPDATE_KIWISAVER, {
        update(proxy){
            setNewKiwiSaver(" ");
            window.location.reload(false);
        },
        onError(err){
            console.log(err);
            setErrors({...errors,name: err.graphQLErrors[0].message});
        },
        variables : { kiwiSaver }
    });

    const [optOutKiwiSaver] = useMutation(UPDATE_KIWISAVER, {
        update(proxy){
            setNewKiwiSaver(" ");
            window.location.reload(false);
        },
        onError(err){
            console.log(err);
            setErrors({...errors,name: err.graphQLErrors[0].message});
        },
        variables : { kiwiSaver : " " }
    });
    
    const handleOnChange = (e, {value}) => {
        setNewKiwiSaver(value);
    }

    const handleChangeKiwiSaver = () => {
        updateKiwiSaver();
    }

    const handleOptOutKiwiSaver = () => {
        optOutKiwiSaver();
    }
    return ( 
        <Fragment>
        <h2>KiwiSaver</h2>
        {userKiwiSaver?(<h3 id="current_kiwisaver">{userKiwiSaver === " " ? "Choose your provider and start saving today!" : "Your current KiwiSaver scheme: " + userKiwiSaver}</h3>):<Loader active inline/>}
        <Table celled id="kiwisaver_table">
            <Table.Header>
            <Table.Row>
                <Table.HeaderCell>ID</Table.HeaderCell>
                <Table.HeaderCell>Provider</Table.HeaderCell>
                <Table.HeaderCell>Fund Type</Table.HeaderCell>
                <Table.HeaderCell>5yr Average</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
            </Table.Header>
            <Table.Body>
            {ProviderList.map((provider) => (
                <Table.Row key={provider.ID}>
                <Table.Cell>{provider.ID}</Table.Cell>
                <Table.Cell>{provider.provider}</Table.Cell>
                <Table.Cell>{provider.fundType}</Table.Cell>
                <Table.Cell>{provider.average}</Table.Cell>
                <Table.Cell>{userKiwiSaver === provider.provider ? "" : <Radio id={provider.provider} class='schemeOptions' name='radioGroup' checked={kiwiSaver===provider.provider} value={provider.provider} onChange={handleOnChange}/>}</Table.Cell>
                </Table.Row>
            ))}
            </Table.Body>
            
        </Table>
        <Modal id="opt_out_kiwisaver_modal" open={openOptOutKiwiSaverModal}  onClose={() => setOptOutKiwiSaverModal(false)} onOpen={() => {setOptOutKiwiSaverModal(true)}} trigger={userKiwiSaver === " " ? "" : <Button id="opt_out_button" color="red" floated='left' disabled={userKiwiSaver === " "}>Opt out</Button>}>
                <Modal.Header>Confirmation</Modal.Header>
                <Modal.Content>Are you sure you want to opt out KiwiSaver ? <br/></Modal.Content>
                <Modal.Actions>
                <Button id="optOutKiwiSaverConfirmNo" color='black' onClick={() => setOptOutKiwiSaverModal(false)}>
                    No
                </Button>
                <Button
                    content="Yes, I would like to opt out."
                    id="optOutKiwiSaverConfirmYes"
                    labelPosition='right'
                    icon='sign out'
                    onClick={() => {
                        handleOptOutKiwiSaver();
                        }}
                    color = "red"
                    />
                </Modal.Actions>
        </Modal>
        <Modal id="change_kiwisaver_modal" open={openChangeKiwiSaverModal}  onClose={() => setChangeKiwiSaverModal(false)} onOpen={() => {setChangeKiwiSaverModal(true)}} trigger={<Button id="change_fund_button" color="teal" floated='right' disabled={kiwiSaver===" "}>Change</Button>}>
                <Modal.Header>Confirmation</Modal.Header>
                <Modal.Content>Are you sure you want to change your KiwiSaver scheme? <br/></Modal.Content>
                <Modal.Actions>
                <Button id="changeKiwiSaverConfirmNo" color='black' onClick={() => setChangeKiwiSaverModal(false)}>
                    No
                </Button>
                <Button
                    content="Yes, I would like to change."
                    id="changeKiwiSaverConfirmYes"
                    labelPosition='right'
                    icon='exchange'
                    onClick={() => {
                        handleChangeKiwiSaver();
                        }}
                    color = "teal"
                    />
                </Modal.Actions>
        </Modal>
        </Fragment>
     );
}

const GET_KIWISAVER_QUERY = gql`
    {
        getUserKiwiSaver
    }  
`;

const UPDATE_KIWISAVER = gql`
    mutation updateKiwiSaver(
        $kiwiSaver: String!
    ) {
        updateKiwiSaver(
            kiwiSaver: $kiwiSaver
        )
    }
`
 
export default KiwiSaver;